import { Context } from "../base";
import { Database } from "./Database";
import { 
    Account,
    Config,
    Counterparty,
    Currency,
    TransactionType,
    Transaction, BlobContent, ExternalFile
    } from "../domain";
import { EntityRepository, CRUDEntityRepository } from './EntityRepository';
import { ObjectRepository } from './ObjectRepository';
import { DashboardWidget } from '../reporting';
import { TransactionRepository, AccountRepository, CurrencyRepository, CounterpartyRepository } from '../repository';
import { Configurations } from '..';
import { ConfigRepository } from '../repository/ConfigRepository';

class RepoCollection {
    private _accRepo: AccountRepository|undefined = undefined;
    private _cpRepo: CounterpartyRepository |undefined = undefined;
    private _transactionTypeRepo: EntityRepository<TransactionType>|undefined = undefined;
    private _currencyRepo: CurrencyRepository|undefined = undefined;
    private _txRepo: TransactionRepository|undefined = undefined;
    private _dashboardWidgetRepo: EntityRepository<DashboardWidget>|undefined = undefined;
    private _blobContentRepo: EntityRepository<BlobContent>|undefined = undefined;
    private _externalFileRepo: EntityRepository<ExternalFile>|undefined = undefined;
    private _init:boolean=false;
    private _db: Database;
    private _configurations: Configurations | undefined = undefined;

    constructor(db:Database) {
        this._db = db;
    }

    async init() {
        if (this._init) {
            return;
        }
        
        const configObjRepo = new ObjectRepository<Config>(this._db.getStore(Config), Config.identity);
        await configObjRepo.init();
        const configRepo = new ConfigRepository(new CRUDEntityRepository(Config, configObjRepo));
        this._configurations = new Configurations(configRepo);

        const accRepository = new ObjectRepository<Account>(this._db.getStore(Account), Account.identity);
        Context.getInstance().registerFinder(Account, accRepository);
        await accRepository.init();
        this._accRepo = new AccountRepository(new CRUDEntityRepository(Account, accRepository));

        const cpRepo = new ObjectRepository<Counterparty>(this._db.getStore(Counterparty), Counterparty.identity);
        Context.getInstance().registerFinder(Counterparty, cpRepo);
        await cpRepo.init();
        this._cpRepo = new CounterpartyRepository(new CRUDEntityRepository(Counterparty, cpRepo));

        const transactionTypeRepo = new ObjectRepository<TransactionType>(this._db.getStore(TransactionType), TransactionType.identity);
        Context.getInstance().registerFinder(TransactionType, transactionTypeRepo);
        await transactionTypeRepo.init();
        this._transactionTypeRepo = new CRUDEntityRepository(TransactionType, transactionTypeRepo);

        const currencyRepo = new ObjectRepository<Currency>(this._db.getStore(Currency), Currency.identity);
        Context.getInstance().registerFinder(Currency, currencyRepo);
        await currencyRepo.init();
        this._currencyRepo = new CurrencyRepository(new CRUDEntityRepository(Currency, currencyRepo));

        const txRepo = new ObjectRepository<Transaction>(this._db.getStore(Transaction), Transaction.identity);
        await txRepo.init();
        this._txRepo = new TransactionRepository(new CRUDEntityRepository(Transaction, txRepo));

        const dashboardWidgetRepo = new ObjectRepository<DashboardWidget>(this._db.getStore(DashboardWidget), DashboardWidget.identity);
        await dashboardWidgetRepo.init();
        this._dashboardWidgetRepo = new CRUDEntityRepository(DashboardWidget, dashboardWidgetRepo);

        const blobContentRepo = new ObjectRepository<BlobContent>(this._db.getStore(BlobContent), BlobContent.identity);
        await blobContentRepo.init();
        Context.getInstance().registerFinder(BlobContent, blobContentRepo);
        this._blobContentRepo = new CRUDEntityRepository(BlobContent, blobContentRepo);        

        const externalFileRepo = new ObjectRepository<ExternalFile>(this._db.getStore(ExternalFile), ExternalFile.identity);
        await externalFileRepo.init();
        Context.getInstance().registerFinder(ExternalFile, externalFileRepo);
        this._externalFileRepo = new CRUDEntityRepository(ExternalFile, externalFileRepo);        

        this._init = true;
    }

    getConfigurations() {
        if (!this._configurations) {
            throw new Error("No init");
        }
        return this._configurations;
    }

    getAccountRepository() {
        if (!this._accRepo) {
            throw new Error("No init");
        }

        return this._accRepo;
    }
    getCurrencyRepository() {
        if (!this._currencyRepo) {
            throw new Error("No init");
        }
        return this._currencyRepo;
    }
    getCounterpartyRepository() {
        if (!this._cpRepo) {
            throw new Error("No init");
        }
        return this._cpRepo;
    }
    getTransactionTypeRepository() {
        if (!this._transactionTypeRepo) {
            throw new Error("No init");
        }
        return this._transactionTypeRepo;
    }
    getTransactionRepository() {
        if (!this._txRepo) {
            throw new Error("No init");
        }
        return this._txRepo;
    }
    getDashboardWidgetRepository() {
        if(!this._dashboardWidgetRepo) {
            throw Error("No init");
        }
        return this._dashboardWidgetRepo;
    }

    getExternalFileRepository() {
        if (!this._externalFileRepo) {
            throw new Error("No init");
        }
        return this._externalFileRepo;
    }

    getBlobContentRepository() {
        if (!this._blobContentRepo) {
            throw new Error("No init");
        }
        return this._blobContentRepo;
    }
}

export { RepoCollection }